import { IFilterObject } from '@ClientModels/filters';
import { ISearchResults } from '@ClientModels/search';
import { ISavedSearchModel } from '@Shared/models';

export const SET_VISIBLE_EXPENSES = 'SET_VISIBLE_EXPENSES';
export const SELECT_EXPENSE = 'SELECT_EXPENSE';
export const UNSELECT_EXPENSE = 'UNSELECT_EXPENSE';
export const SELECT_ALL_EXPENSES = 'SELECT_ALL_EXPENSES';
export const UNSELECT_ALL_EXPENSES = 'UNSELECT_ALL_EXPENSES';
export const CHECK_EXPENSE = 'CHECK_EXPENSE';
export const UNCHECK_EXPENSE = 'UNCHECK_EXPENSE';
export const CHECK_ALL_EXPENSES = 'CHECK_ALL_EXPENSES';
export const UNCHECK_ALL_EXPENSES = 'UNCHECK_ALL_EXPENSES';
export const RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS';
export const ACTIVATE_FILTER = 'ACTIVATE_FILTER';
export const ACTIVATE_FILTERS = 'ACTIVATE_FILTERS';
export const DEACTIVATE_FILTER = 'DEACTIVATE_FILTER';
export const DEACTIVATE_AMOUNT_FILTERS = 'DEACTIVATE_AMOUNT_FILTERS';
export const DEACTIVATE_ALL_FILTERS = 'DEACTIVATE_ALL_FILTERS';
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const OPEN_DATE_RANGE_FILTER = 'OPEN_DATE_RANGE_FILTER';
export const CLOSE_DATE_RANGE_FILTER = 'CLOSE_DATE_RANGE_FILTER';
export const SET_SEARCH_VIEW = 'SET_SEARCH_VIEW';
export const INCREMENT_REQUEST_COUNT = 'INCREMENT_REQUEST_COUNT';
export const DECREMENT_REQUEST_COUNT = 'DECREMENT_REQUEST_COUNT';
export const SELECT_SAVED_SEARCH = 'SELECT_SAVED_SEARCH';

export class SetVisibleExpenses {
  readonly type = SET_VISIBLE_EXPENSES;
  constructor(public expenseIds: string[]) {}
}

export class SelectExpense {
  readonly type = SELECT_EXPENSE;
  constructor(public expenseId: string) {}
}

export class UnselectExpense {
  readonly type = UNSELECT_EXPENSE;
}

export class CheckExpense {
  readonly type = CHECK_EXPENSE;
  constructor(public expenseId: string) {}
}

export class UncheckExpense {
  readonly type = UNCHECK_EXPENSE;
  constructor(public expenseId: string) {}
}

export class CheckAllExpenses {
  readonly type = CHECK_ALL_EXPENSES;
  constructor(public expenseIds: string[]) {}
}

export class UncheckAllExpenses {
  readonly type = UNCHECK_ALL_EXPENSES;
}

export class ReceiveSearchResults {
  readonly type = RECEIVE_SEARCH_RESULTS;
  constructor(public results: ISearchResults) {}
}

export class SelectAllExpenses {
  readonly type = SELECT_ALL_EXPENSES;
}

export class UnselectAllExpenses {
  readonly type = UNSELECT_ALL_EXPENSES;
}

export class ActivateFilter {
  readonly type = ACTIVATE_FILTER;
  constructor(public filterName: string, public value: IFilterObject[], public filterType = 'general') {}
}

export class ActivateFilters {
  readonly type = ACTIVATE_FILTERS;
  constructor(public filters: IFilterObject) {} // for saved searches really
}

export class DeactivateFilter {
  readonly type = DEACTIVATE_FILTER;
  constructor(public filterName: string, public value: Partial<IFilterObject>[], public filterType = 'general') {}
}

export class DeactivateAmountFilters {
  readonly type = DEACTIVATE_AMOUNT_FILTERS;
}

export class DeactivateAllFilters {
  readonly type = DEACTIVATE_ALL_FILTERS;
}

export class OpenMenu {
  readonly type = OPEN_MENU;
}

export class CloseMenu {
  readonly type = CLOSE_MENU;
}

export class OpenDateRangeFilter {
  readonly type = OPEN_DATE_RANGE_FILTER;
}

export class CloseDateRangeFilter {
  readonly type = CLOSE_DATE_RANGE_FILTER;
}

export class SetSearchView {
  readonly type = SET_SEARCH_VIEW;
  constructor(public view: string) {}
}

export class IncrementRequestCount {
  readonly type = INCREMENT_REQUEST_COUNT;
}

export class DecrementRequestCount {
  readonly type = DECREMENT_REQUEST_COUNT;
}

export class SelectSavedSearch {
  readonly type = SELECT_SAVED_SEARCH;
  constructor(public savedSearch: ISavedSearchModel | null) {}
}

export type SearchAction =
  | SetVisibleExpenses
  | SelectExpense
  | UnselectExpense
  | CheckExpense
  | UncheckExpense
  | CheckAllExpenses
  | UncheckAllExpenses
  | ReceiveSearchResults
  | SelectAllExpenses
  | UnselectAllExpenses
  | ActivateFilter
  | ActivateFilters
  | DeactivateFilter
  | DeactivateAmountFilters
  | DeactivateAllFilters
  | OpenMenu
  | CloseMenu
  | OpenDateRangeFilter
  | CloseDateRangeFilter
  | SetSearchView
  | IncrementRequestCount
  | DecrementRequestCount
  | SelectSavedSearch;
